import { observable, computed } from 'mobx';
import axios from 'axios';
import { getCache } from "../helpers/cache";

class ProviderLabelStore {
  @observable accessor providers = [];
  @observable accessor labels= [];

  constructor() {
    this.getProviders();
    this.getLabels();

    this.getProviders = this.getProviders.bind(this);
    this.getLabels = this.getLabels.bind(this);
  }

  async getProviders() {
    const cacheMissCallback = async () => {
      const providers = await axios.get('/providers');

      return providers;
    };

    const response = await getCache('providers', cacheMissCallback);

    this.providers = response.data.sort((a, b) => {
      const aName = a.name.toUpperCase();
      const bName = b.name.toUpperCase();
      let result;

      if (aName !== bName) {
        result = aName < bName ? -1 : 1;
      } else {
        result = 0;
      }

      return result;
    }).map(provider => ({ ...provider, value: provider.id }));

    return this.providers;
  }

  async getLabels() {
    const cacheMissCallback = async () => {
      const labels = await axios.get('/labels');

      return labels;
    };

    const response = await getCache('labels', cacheMissCallback);

    this.labels = response.data.sort((a, b) => {
      const aName = a.name.toUpperCase();
      const bName = b.name.toUpperCase();
      let result;

      if (aName !== bName) {
        result = aName < bName ? -1 : 1;
      } else {
        result = 0;
      }

      return result;
    }).map(label => ({ ...label, name: label.labelName, value: label.id }));

    return this.labels;
  }

  @computed get allProviders() {
    return this.providers;
  }

  @computed get allLabels() {
    return this.labels;
  }
}

const ProviderLabelData = new ProviderLabelStore();

export default ProviderLabelData;
